import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Logo } from '../../../web/src/components/navigation/logo.jsx';
import { Link } from '../../../web/src/components/navigation/link.jsx';
import { LanguageToggle } from './language-toggle.jsx';
import { APP_URL } from '../app-config.js';

/**
 * Marketing-site footer: tagline, links, and the language
 * toggle. Reuses the app's copyright string from the shared locale.
 * @returns {JSX.Element}
 */
export function SiteFooter() {
	const { lang } = useParams();
	const { t } = useTranslation();
	return (
		<footer className="site-footer">
			<div className="site-footer-brand">
				<Logo size={24} className="site-brand-logo" />
				<p className="site-footer-tagline">{t('site.footer.tagline')}</p>
			</div>
			<nav className="site-footer-links" aria-label={t('site.footer.links')}>
				<Link to={`/${lang}/story/`}>{t('site.nav.story')}</Link>
				<Link to={`/${lang}/use-cases/`}>{t('site.nav.useCases')}</Link>
				<Link to={`/${lang}/pricing/`}>{t('site.nav.pricing')}</Link>
				<Link to={`/${lang}/terms/`}>{t('site.nav.terms')}</Link>
				<Link to={`/${lang}/privacy/`}>{t('site.nav.privacy')}</Link>
				<a href={APP_URL} target="_blank" rel="noreferrer">{t('site.nav.goToApp')}</a>
			</nav>
			<div className="site-footer-bottom">
				<span>{t('footer.copyright')}</span>
				<LanguageToggle />
			</div>
		</footer>
	);
}
